const isInteger = (str: string): boolean => /^[+-]?[0-9]+$/.test(str);

export default isInteger;
